import { Injectable } from '@angular/core';
import {
  ReportResult,
  ReportType,
  formatReportCellValue,
  toIsoDate,
} from './report-types';

@Injectable({
  providedIn: 'root',
})
export class ReportsCsvExportService {
  createDownload(result: ReportResult, reportType: ReportType): { url: string; fileName: string } {
    const csv = this.buildCsv(result);
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);

    return {
      url,
      fileName: `${reportType}-${toIsoDate(new Date())}.csv`,
    };
  }

  revoke(url: string | null): void {
    if (url) {
      URL.revokeObjectURL(url);
    }
  }

  private buildCsv(result: ReportResult): string {
    const header = result.columns.map((column) => this.escapeCsvCell(column.label)).join(',');
    const rows = result.rows.map((row) =>
      result.columns
        .map((column) => this.escapeCsvCell(formatReportCellValue(row[column.key])))
        .join(','),
    );

    return [header, ...rows].join('\n');
  }

  private escapeCsvCell(value: string): string {
    const escaped = value.replaceAll('"', '""');
    return `"${escaped}"`;
  }
}
